import { formatServerTime, serverTimeMs } from './serverTime';

/**
 * デュエル一覧の並び（Issue #616）。
 *
 * - `name`: デュエル名の順（`localeCompare('ja')`。かなはあいうえお順、漢字は読みではなく文字コード）
 * - `updated`: 更新日時の新しい順。更新日時は `GetDuelListProject` が返す `updated_at`
 *   （デュエル行と試合行の updated_at の最大。DB のトリガーが操作ログ・登録・応答などの
 *   書き込みで触る）。無いもの（移行前で活動の記録が無いデュエル）は末尾、同時刻は名前順
 *
 * 保存のキーと既定もここ（ページはこれを読むだけ）。
 */
export const DUEL_SORTS = ['name', 'updated'];
export const DUEL_SORT_LABEL = { name: '名前順', updated: '更新順' };
export const DUEL_SORT_STORAGE_KEY = 'duelList.sort';
export const DEFAULT_DUEL_SORT = 'name';

const byName = (a, b) => (a.name ?? '').localeCompare(b.name ?? '', 'ja');

/** 更新日時を ms に。無い・読めないものは null（末尾へ） */
export function updatedAtMs(duel) {
  if (!duel?.updated_at) return null;
  return serverTimeMs(duel.updated_at);
}

export function sortDuels(duels, sort = DEFAULT_DUEL_SORT) {
  const arr = duels.slice();
  if (sort !== 'updated') return arr.sort(byName);
  return arr.sort((a, b) => {
    const ta = updatedAtMs(a);
    const tb = updatedAtMs(b);
    if (ta === tb) return byName(a, b);
    if (ta === null) return 1;
    if (tb === null) return -1;
    return tb - ta;
  });
}

export function loadDuelSort(storage = typeof window !== "undefined" ? window.localStorage : null) {
  try {
    const v = storage?.getItem(DUEL_SORT_STORAGE_KEY);
    return DUEL_SORTS.includes(v) ? v : DEFAULT_DUEL_SORT;
  } catch {
    return DEFAULT_DUEL_SORT;
  }
}

export function saveDuelSort(sort, storage = typeof window !== "undefined" ? window.localStorage : null) {
  try {
    storage?.setItem(DUEL_SORT_STORAGE_KEY, sort);
  } catch {
    // プライベートウィンドウなどで書けないときは覚えないだけ
  }
}

/** 一覧に出す更新日時の文字。無ければ null */
export function formatUpdatedAt(duel) {
  const ms = updatedAtMs(duel);
  return ms === null ? null : formatServerTime(ms, {
    year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit',
  });
}
